define(function(require) {
	const Marionette = require('backbone.marionette');
	const edit_site_search_results_tpl = require('./t_itv_edit_site_search_results.hbs');
	const siteBuilder = require('civicsUtils/site_builder');
	return Marionette.ItemView.extend({
		template:edit_site_search_results_tpl,
		initialize:function(options){
			this.config = options.config
			var m = this.model.toJSON()
			switch (this.model.get('type').toLowerCase()){
				case 'parcel':
					if(this.config.parcelAllowed){
						this.siteID = this.model.get('id');
						this.siteDescription = siteBuilder.buildLocationLine1(m);
					}else {
						this.destroyMe = true
						this.siteID = null,
						this.siteDescription = i18n.t('CIVICS.COMMON_EDIT_SITES.SITE_ERROR_MSG');
					}
					break;
				case 'address':
					if (this.config.addressAllowed) {
						this.siteID = this.model.get('id'),
						this.siteDescription = siteBuilder.buildLocationLine1(m)+' '+siteBuilder.buildLocationLine2(m);
					}
					else {
						this.destroyMe = true
						this.siteID = null,
						this.siteDescription = i18n.t('CIVICS.COMMON_EDIT_SITES.SITE_ERROR_MSG');
					}
					break;
				case 'coords':
					if(this.config.coordsAllowed){
						this.siteID = this.model.get('id'),
						this.siteDescription = siteBuilder.buildLocationLine1(m)+'<br/>'+siteBuilder.buildLocationLine2(m)
					} else {
						this.destroyMe = true
						this.siteID = null,
						this.siteDescription = i18n.t('CIVICS.COMMON_EDIT_SITES.SITE_ERROR_MSG');
					}
					break;
				default:
					this.destroyMe = true
					this.siteID = null,
					this.siteDescription = i18n.t('CIVICS.COMMON_EDIT_SITES.SITE_ERROR_MSG');
					if(__DEV__) console.log('Bad site model',this.model);
					break;
			}

		},
		tagName:'li',
		events:{
			'click @ui.inputRadio':'siteSelected'
		},
		ui:{
			inputRadio:'.input-radio'
		},
		onShow:function(){
			if(this.destroyMe === true){
				this.destroy();
			}
		},
		siteSelected:function(e){
			this.triggerMethod('radioButton:clicked',
				$(e.target).val(),
				$('label[for="'+e.target.id+'"]').html(),
				this.model
				);
		},
		templateHelpers:function(){
			var self = this;
			return {
				siteID: this.siteID != null ? this.siteID : "NonHansenSite" + Math.floor(Math.random() * 100000),
				siteDescription:this.siteDescription,
				disabled:function(){
					if(!self.config.allowNonHansenSites && (self.model.get('id') == null || self.model.get('id') == '')){
						return true;
					} else {
						return false;
					}
				},
				labelText: function(){
					var str =self.siteDescription;
					if(!self.config.allowNonHansenSites && (self.model.get('id') == null || self.model.get('id') == '')){
						str+="<br/>";
						if(self.model.get('type').toLowerCase()=='address'){
							str+=i18n.t('CIVICS.COMMON_EDIT_SITES.ADDRESS_NOT_IN_SYSTEM');
						}else if(self.model.get('type').toLowerCase() == 'parcel'){
							str+=i18n.t('CIVICS.COMMON_EDIT_SITES.PARCEL_NOT_IN_SYSTEM')
						}
					}

					return str;
				}
			}
		}
	});
});
